import s from './Summary.scss'
import cn from 'classnames'

const Summary = ({ summary, style }) => {
  return (
    <div style={style} className={cn(s.column, s.bold)}>
      <div className={s.row}>
        <span>Billable</span>
        <span>{summary.billable} hrs</span>
      </div>
      <div className={s.row}>
        <span>Non-billable</span>
        <span>{summary.nonBillable} hrs</span>
      </div>
      <div className={cn(s.row, s.borderBottom)}>
        <span>Overtime</span>
        <span>{summary.overtime} hrs</span>
      </div>
      <div className={s.row}>
        <span>TOTAL</span>
        <span>{summary.total} hrs</span>
      </div>
      <div style={{ marginTop: 5 }} className={s.row}>
        <span>Remaining</span>
        <span>{summary.remaining} hrs</span>
      </div>
    </div>
  )
}

export default Summary
